var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCurrentRenderedTile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5717 6.14509H15.5717V5.00223C15.5717 4.92366 15.5074 4.85938 15.4289 4.85938H14.4289C14.3503 4.85938 14.286 4.92366 14.286 5.00223V6.14509H9.71457V5.00223C9.71457 4.92366 9.65028 4.85938 9.57171 4.85938H8.57171C8.49314 4.85938 8.42885 4.92366 8.42885 5.00223V6.14509H5.42885C5.11278 6.14509 4.85742 6.40045 4.85742 6.71652V18.5737C4.85742 18.8897 5.11278 19.1451 5.42885 19.1451H18.5717C18.8878 19.1451 19.1431 18.8897 19.1431 18.5737V6.71652C19.1431 6.40045 18.8878 6.14509 18.5717 6.14509ZM17.8574 17.8594H6.14314V7.4308H8.42885V8.28795C8.42885 8.36652 8.49314 8.4308 8.57171 8.4308H9.57171C9.65028 8.4308 9.71457 8.36652 9.71457 8.28795V7.4308H14.286V8.28795C14.286 8.36652 14.3503 8.4308 14.4289 8.4308H15.4289C15.5074 8.4308 15.5717 8.36652 15.5717 8.28795V7.4308H17.8574V17.8594ZM15.1431 10.3594H14.1574C14.0664 10.3594 13.9789 10.404 13.9253 10.4772L11.2306 14.1879L10.0753 12.5987C10.0217 12.5254 9.93599 12.4808 9.84314 12.4808H8.85742C8.74135 12.4808 8.67349 12.6129 8.74135 12.7076L10.9985 15.8147C11.0252 15.8513 11.0601 15.881 11.1005 15.9015C11.1408 15.922 11.1854 15.9326 11.2306 15.9326C11.2759 15.9326 11.3205 15.922 11.3608 15.9015C11.4012 15.881 11.4361 15.8513 11.4628 15.8147L15.2592 10.5879C15.3271 10.4915 15.2592 10.3594 15.1431 10.3594Z",
    fill: "#666666"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentRenderedTile);
export default ForwardRef;